import SettingsItem from './SettingsItem';
export default SettingsItem;